/** User-facing copy when tapping another detective cannot start follow. */

export type PeerTapBlockedReason =
  | "solo"
  | "caseFrozen"
  | "following"
  | "arrest"
  | "peerHidden"
  | "depsMissing";

export function peerTapBlockedMessage(reason: PeerTapBlockedReason): string {
  switch (reason) {
    case "solo":
      return "Need at least two detectives in this case to follow a partner.";
    case "caseFrozen":
      return "This case is closed — following is not available.";
    case "following":
      return "Stop following before tapping another detective.";
    case "arrest":
      return "Arrest phase — following is not available.";
    case "peerHidden":
      return "That detective is in another area — move to the same zone to follow.";
    case "depsMissing":
    default:
      return "Could not follow — try again.";
  }
}
